import React from 'react';
import { Row, Col } from '@teko/ds-desktop';
import { getTrackingData } from '@teko/tracking';
import { EnhancedImage } from '../EnhancedImage/EnhancedImage.es.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const FeaturedBanners = ({
  banners,
  regionName,
  prioritized
}) => {
  if (!banners || !banners.length)
    return null;
  const googleImageWidth = Math.ceil(1232 / banners.length);
  return /* @__PURE__ */ React.createElement(Row, {
    gutter: [16, 16]
  }, banners.map((banner, index) => {
    var _a;
    return /* @__PURE__ */ React.createElement(Col, {
      span: 12 / banners.length,
      key: index
    }, /* @__PURE__ */ React.createElement(EnhancedImage, __spreadProps(__spreadValues({
      borderRadius: "8px"
    }, banner), {
      tracking: getTrackingData({
        regionName: regionName || `horizontalBanner${banners.length}`,
        index,
        target: (_a = banner == null ? void 0 : banner.link) == null ? void 0 : _a.href,
        contentName: banner == null ? void 0 : banner.name,
        isTrackContent: true
      }),
      hover: "zoom",
      googleImageParams: {
        width: googleImageWidth
      },
      fetchPriority: prioritized ? "high" : "auto",
      alt: (banner == null ? void 0 : banner.name) || ""
    })));
  }));
};

export { FeaturedBanners };
